<template>
    <header
        :class="[
           'checker-page-header',
           'checker-page-header--is-sticky'
        ]"
    >
        <div class="checker-page-header__mainWrapper">
            <div class="checker-page-header__brand">
                <h1>UI Checker</h1>
                <span>(Part of DX+ tools for MOM)</span>
            </div>
            <div style="display: flex">
                <a href="https://dxplus.mom.gov.sg/documents/UI_checker_user_manual.pdf" target="_blank">
                    <img src="../../assets/help-icon.png" class="checker-page-header__icon"/>
                </a>
                <span v-if="loggedIn" v-on:click="logOut" class="checker-page-header__logout">Logout</span>
            </div>
        </div>
        
    </header>
</template>

<script>
export default {
    name: "CheckerPageHeader",
    data() {
        return {
            logoutTimer: null,
        }
    },
    mounted() {
        this.setLogoutTimer();
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        }
    },
    methods: {
        logOut(){
            this.$store.dispatch('auth/logout');
            this.$router.push('/Login').catch(()=>{});
        },
        setLogoutTimer(){
            console.log(this.logoutTimer)
            this.logoutTimer = setTimeout(this.logOut, 30*60*1000)
        },
        // resetLogoutTimer(){
        //     clearTimeout(this.logoutTimer);
        //     if (this.loggedIn){
        //         this.setLogoutTimer();
        //     }else{
        //         this.logOut()
        //     } 
        // }
    },
}
</script>

<style lang="scss">
.checker-page-header {
    background-color: $color-blue-80;
    color: $color-white;
}

.checker-page-header--is-sticky {
    position: relative;
    width: 100%;
    z-index: $z-index-sticky;
    box-shadow: $box-shadow-header;

    @media print {
        position: relative;
    }

    @include min-width(tablet) {
        position: fixed;
        top: 0;
        left: 0;
    }
}

.checker-page-header__mainWrapper {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: rem(20) rem(30);
}

.checker-page-header__brand {
    display: flex;
    align-items: baseline;
    gap: rem(5);

    h1 {
        @include font-size(l);
    }

    span {
        @include font-size(s);
    }
}

.checker-page-header__logout {
    @include font-size(l);
    cursor: pointer;
}

.checker-page-header__icon {
    margin-right: 2rem;
    height: 25px;
    width: 25px;
}

</style>